import React from "react";
import { QRCodeCanvas } from "qrcode.react";

interface QRCodeGeneratorProps {
  value: string;
  size?: number;
  bgColor?: string;
  fgColor?: string;
  level?: "L" | "M" | "Q" | "H";
}

const QRCodeGenerator: React.FC<QRCodeGeneratorProps> = ({
  value,
  size = 60,
  bgColor = "transparent",
  fgColor = "#000000",
  level = "M",
}) => {
  return (
    <QRCodeCanvas
      value={value}
      size={size}
      bgColor={bgColor}
      fgColor={fgColor}
      level={level}
      includeMargin={true}
    />
  );
};

export default React.memo(QRCodeGenerator);
